// cleanup_convert_to_typescript_file_LOGIN_WORKFLOW

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useTheme } from '@glu/theming';

import FdicLogo, { FDIC_LOGO_VARIANTS } from 'components/fdicLogo';

import LoginForm from './LoginForm';
import useStyles from './LeftPanel.styles';

export const LeftPanelComponent = ({ className, locale, sessionValue }) => {
  const { heading1, logo, logoContainer, panelLeft } = useStyles();
  const {
    images: { logos },
    title
  } = useTheme();

  return (
    <div data-qa="login-left-panel" className={classnames(panelLeft, className)}>
      <>
        <header>
          <h1 className={heading1}>{title || locale['common.appTitle']}</h1>
          <div className={logoContainer}>
            <img
              className={logo}
              src={logos.login}
              alt={locale.logoAltTxt || locale['common.brandLogo']}
            />
          </div>
          <FdicLogo type={FDIC_LOGO_VARIANTS.LOGIN} />
        </header>
        <aside className="alert-region" />
      </>
      <main>
        <LoginForm locale={locale} sessionValue={sessionValue} />
      </main>
    </div>
  );
};

LeftPanelComponent.propTypes = {
  className: PropTypes.string,
  locale: PropTypes.shape({}).isRequired,
  sessionValue: PropTypes.string,
  theme: PropTypes.shape({}).isRequired
};

LeftPanelComponent.defaultProps = {
  className: '',
  sessionValue: null
};

export default LeftPanelComponent;
